import React, {useState, useEffect} from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import ToggleButton from 'react-toggle-button';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getActionTaken, getActionTakenForAE, getAllCausalities, getAllOutComes, getPIData, getPiStudies, getSAdvEvents, getStudyAeDetails, getStudyTitles, getSubjectNumber,  } from '../../../Redux/actions/actions';
import InputComponent from '../../ReusableComp/InputComponent';
import { Col,  Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { EVENT_CLASSIFICATION_AESI, EVENT_CLASSIFICATION_GRADE_CTCAE, EVENT_CLASSIFICATION_LEVEL_BRIGHTON, EVENT_CLASSIFICATION_OTHER, TOGGLE_NO, TOGGLE_YES, base_url } from '../../../utilities';
import BrightonCase from './BrightonCase';
import GradeCase from './GradeCase';
import axios from '../../../axios-interceptor';
import PopUpModal from '../../ReusableComp/PopUpModal';
import { useNavigate } from 'react-router';
import moment from 'moment';
import Loader from '../../ReusableComp/Loader'; // Import the Loader component
import { useLocation } from 'react-router-dom';


export default function SubjectRegistration() {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [radioValue, setRadioValue]= useState('')
  function handleRadioBtn(val){
    setRadioValue(val)
  }
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

const rejSubj = location?.state?.rejSubjDetls;
const dsblFrRejSub = rejSubj?.subject_id !== undefined

const [study_id, setStudy_id] = useState([])
const [btnDisable, setBtnDisable] = useState(false)
const [regStep, setRegStep] = useState(1);
const [toggleSAE, setToggleSAE] = useState(false);

const piStudyData = useSelector((state) => (state.piStudyList));
const piDetails = useSelector((state) => (state.piDetails));
const optedStudy = piStudyData&& piStudyData.find(i => i.study_id === study_id[0])
const minxDate = optedStudy?.study_initiation_date
  ? moment(optedStudy.study_initiation_date).format("YYYY-MM-DD")
  : moment().format("YYYY-MM-DD");
const saEvents = useSelector((state) => state.getSAEvents);
const studyTitles = useSelector((state) => state.getStdyTitls);
const subjNumber = useSelector((state) => state.getSubjNum);
const causalities = useSelector((state) => state.getCausalities);
const studyAeDtls = useSelector((state) => state.getStudyAeDtls);
const outComes = useSelector((state) => state.getOutComes);
const actnTakenOpts = useSelector((state) => state.actionTaken);
const actionTakenforAe = useSelector((state) => state.actionTakenforAe);
const [error, setError] = useState('');
const [flag, setFlag] = useState(true);
const [newFlag,setNewFlag]=useState("");
const [error1, setError1] = useState('');
const [werror, setWerror1] = useState('');



    useEffect(() => {
        if(window.location.pathname ==='/subjectregistration' && regStep!==1){
            setBtnDisable(true)
          }else{
              setBtnDisable(false)
          }
        dispatch(getPIData(localStorage.login_user_id))
        dispatch(getSAdvEvents())
        dispatch(getAllOutComes())
        dispatch(getActionTaken())
        dispatch(getActionTakenForAE())
        dispatch(getPiStudies())
        dispatch(getAllCausalities())
        dispatch(getStudyTitles(study_id[0]))
        dispatch(getSubjectNumber(study_id[0]))
       
    }, [dispatch,regStep, localStorage.login_user_id, study_id, btnDisable])
 
    const [medicationDetails, setMedicationDetails] = useState([
      {
        "medication": "",
        "medication_manufacturer": "",
        "medication_batch_number": "",
        "medication_route_site": "",
        "medication_dosage":"",
        "medication_frequency": "",
        "current_idx":1
      },
    ]); 
    
    let [medUsedInLast3WeeksDetails, setMedUsedInLast3WeeksDetails] = useState([
      {
        "medication_name": "",
        "medication_route": "",
        "dosage":"",
        "frequency": "",
        "current_idx":1
      },
    ]); 


const handleSaeToggle=()=>{
  setToggleSAE(!toggleSAE) 
  setDateofOnsetSAE('')
  setSeriousAE('')
  setSearchTerm('')
  setBtnTitle('Select Adverse Criteria')
}


let medicationDtlsBtn = medicationDetails?.some(detail => {
  let indx=detail.current_idx;
  delete detail.current_idx;
  let x= !Object.values(detail).every(value => value.length)
  detail.current_idx=indx;
  return x
})

let medUsedInLast3WeeksDtlsBtn= medUsedInLast3WeeksDetails?.some(detail => {
  let indx=detail.current_idx;
  delete detail.current_idx;
  let x= !Object.values(detail).every(value => value.length)
  detail.current_idx=indx;
  return x
})


    let piSiteDetails = piDetails?.pi_sites
    const registrationSteps = [
        {
            stepTitle: "1. Subject details",
            description:"Age, Sex, Weight, Phone, etc."
        },
        {
            stepTitle: "2. Site Information",
            description:"City, State, Site, etc."
        },
        {
            stepTitle: "3. Past health history",
            description:"Allergies, medication etc."
        },
        {
            stepTitle: "4. Dose details",
            description:"Dose 1, Dose 2, etc."
        },
        {
            stepTitle: "5. Adverse Events",
            description:"Adverse Events"
        },
        {
            stepTitle: "6. Concomitant Medication",
            description:"Concurrent Medication"
        },
        {
            stepTitle: "7. Preview and Confirm",
            description:"Summary of subject registration"
        },
        
    ];
    const [subjPhone, setSubjPhone] = useState("");
    const [age, setAge] = useState("");
    const [gender, setGender] = useState(rejSubj?.sex ||'');
    const [weight, setWeight] = useState("")
    const [height, setHeight] = useState("")
    const [bmi, setBMI] = useState('');
    const [today, setToday] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [btnTitle, setBtnTitle] = useState("");


    const [selectedOption, setSelectedOption] = useState('');
    const [seriousAE, setSeriousAE] = useState({});
    const [dateofOnsetSAE, setDateofOnsetSAE] = useState("");
    const [aEClassification, setAEClassification] = useState("");
    const [fileNames, setFileNames] = useState([]);
    const [file, setFile] = useState([]);
    const [city1, setCity1] = useState("");
    const [subNumber, setSubNumber] = useState("");
    const [anyAllergies, setAnyAllergies] = useState("")
    const [medicationsUsed, setMedicationsUsed] = useState("")
    const [medicalHistory, setMedicalHistory] = useState("")
    const [ConcurrentIllness, setConcurrentIllness] = useState("")
    const [study, setStudy] = useState("");
    const [dose, setDose] = useState(1);
    const [dateOfAdministration, setDateOfAdministration] = useState("")
    const [timeOfAdministration, setTimeOfAdministration]=useState("")
    const [anatomical, setAnatomical] = useState("")
    const [batchNumber, setBatchNumber] = useState("")
    const [expiry, setExpiry] = useState("")
    const [dateOfManu, setDateOfManu] = useState("")
    const [actionAdverse,setActionAdverse]=useState("Select");
    const [choosenOption, setChoosenOption] = useState('Select');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [dataOfOnset, setDateOfOnset] = useState("");
    const [timeOfOnset, setTimeOfOnset] = useState("");
    const [dateOfResolution, setDateOfResolution] = useState(null);
    const [timeOfResolution, setTimeOfResolution] = useState(null)
    const [treatmentGiven, setTreatmentGiven] = useState("")
    const [phoneValidation, setPhoneValidation] = useState(false)
    const [caseID, setCaseID] =useState()


    
    const handleDateOfOnsetChange = (e) => {
        setDateOfOnset(e.target.value);
        };
    const handleTimeOfOnsetChange = (e) => {
        setTimeOfOnset(e.target.value);
        };
    const handleDateOfResolutionChange = (e) => {
        setDateOfResolution(e.target.value);
        };
    const handleTimeOfResolutionChange = (e) => {
        setTimeOfResolution(e.target.value);
        };
    
    const handleDateOfManuChange = (e) => {
      
        setDateOfManu(e.target.value);
        };

    const handleExpiryChange = (e) => {
        setExpiry(e.target.value);
        };
 
    const handleBatchNumberChange = (e) => {
        setBatchNumber(e.target.value);
        };

        function handleSearch(e) {
          setSearchTerm(e.target.value);
      }
    function handleDropDown() {
          setShowPopup(!showPopup)
          setSearchTerm('');
  
      }

    const handleTimeOfAdministrationChange = (e) => {
        setTimeOfAdministration(e.target.value);
        };

    const handleStudyChange = (e) => {
        setStudy(e.target.value);
        };
    
    // const handleDoseChange = (e) => {
    //      let value = e.target.value
    //     if(value !='Select'){
    //         setDose(value)}
    //     else{setDose('')}
    //     };
    const handleDateOfAdministrationChange = (e) => {
      
        setDateOfAdministration(e.target.value);
        fifthInputs.date_of_onset = ""
 
        
        };

    const handleAllergyChange = (e) => {
        setAnyAllergies(e.target.value);
        
        };

    const handleMedicationUsedChange = (e) => {
        setMedicationsUsed(e.target.value);
        };

    const handleMedicalHistoryChange = (e) => {
        setMedicalHistory(e.target.value);
        };
    const handleConcurrentIllnessChange = (e) => {
        setConcurrentIllness(e.target.value);
        };
    
    const handleSubjectNumberChange = (e) => {
        setSubNumber(e.target.value);
        };
 
    const handleCity1Change = (e) => {
        setCity1(e.target.value);
        };

        const handleFileUpload = (event) => {
          const maxIndividualFileSize = 10 * 1024 * 1024; // 10MB in bytes
          const maxCombinedFileSize = 30 * 1024 * 1024; // 30MB in bytes
          const maxFiles = 3; // Maximum allowed files
        
          const files = Array.from(event.target.files);
          const totalSize = files.reduce((acc, file) => acc + file.size, 0);
         
          if (files.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} files`, {
              toastId: 9,
            });
          } else if (files.every((file) => file.size <= maxIndividualFileSize) && totalSize <= maxCombinedFileSize) {
            const newFileNames = files.map((file) => file.name);
            const newFile = files;
            setFile((prevFile) => [...prevFile, ...newFile]);
            setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
          } else {
            if (!files.every((file) => file.size <= maxIndividualFileSize)) {
              toast.error("File size should be less than 10 MB", {
                toastId: 7,
              });
            }
            
          }
        };
        const handleDrop = (event) => {
          event.preventDefault(); // Prevent automatic preview
          if (event.dataTransfer.items) {
            const files1 = event.dataTransfer.items;
            const fileList = Array.from(files1).map((item) => item.getAsFile());
            const maxIndividualFileSize = 10 * 1024 * 1024; // 10MB in bytes
            const maxCombinedFileSize = 30 * 1024 * 1024; // 30MB in bytes
            const maxFiles = 3; // Maximum allowed files
            const files = Array.from(fileList);
            const totalSize = files.reduce((acc, file) => acc + file.size, 0);
            if(file.length<3){
            if (files.length > maxFiles) {
              toast.error(`You can upload a maximum of ${maxFiles} files`, {
                toastId: 9,
              });
            } else if (
              files.every((file) => file.size <= maxIndividualFileSize) &&
              totalSize <= maxCombinedFileSize
            ) {
              const newFileNames = files.map((file) => file.name);
              const newFile = files;
              setFile((prevFile) => [...prevFile, ...newFile]);
              setFileNames((prevFileNames) => [...prevFileNames, ...newFileNames]);
            } else {
              if (!files.every((file) => file.size <= maxIndividualFileSize)) {
                toast.error("File size should be less than 10 MB", {
                  toastId: 7,
                });
              }
            }
          }
            else{
              toast.error(`You can upload a maximum of ${maxFiles} files`, {
                toastId: 9,
              });
            }
        }
        };
          const handleRemoveFile = (index) => {
            setFileNames((prevFileNames) => {
              const newFileNames = [...prevFileNames];
              newFileNames.splice(index, 1);
              return newFileNames;
            });
            setFile((prevFileNames) => {
              const newFileNames = [...prevFileNames];
              newFileNames.splice(index, 1);
              return newFileNames;
            });
          };
    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleDateOfOnsetSae = (e) => {
        setDateofOnsetSAE(e.target.value);
    };
    // const handleSeriousChangeAE = (option) => {
    //     setSeriousAE(option);
    // };
const [caseDef, setCaseDef] =useState()
const [radioReset, setRadioReset] =useState('')
 

const handleReset=()=>{
  setRadioReset('')
}
const [aeLabel, setAeLabel]  = useState('')
const handleAEClassification=(i)=>{
  if(i.target.value !=='Select Adverse Event')
  {
const case_def = Number(i.target.options[i.target.selectedIndex].getAttribute('case_def'))
const optionValue = (i.target.options[i.target.selectedIndex].getAttribute('value'))
const optionLabel=(i.target.options[i.target.selectedIndex].getAttribute('label'))
setAeLabel(optionLabel)
  setEventDesc('')
  setRadioValue('')
  setRadioReset('reset')
  setValuForDisble()
  setInputTextNotes('')
  setTreatmentGiven('')
  setTimeOfResolution('')
  setDateOfResolution('')
  setFifthInputs((prev) => {
    const blankState = {};
    for (const key in prev) {
      blankState[key] = "";
    }
    return blankState;
  });

  
        setCaseDef(case_def)
        setCaseID(optionValue)
        setAEClassification(optionValue)

        if(case_def !== EVENT_CLASSIFICATION_OTHER)
        {
          dispatch(getStudyAeDetails(i))
        }
        
      if(case_def=== EVENT_CLASSIFICATION_OTHER  ){
        setEventDesc({study_aebank_id:optionValue, event_description_id:null})
      }
      if(case_def=== EVENT_CLASSIFICATION_AESI  ){
        setEventDesc({study_aebank_id:optionValue})
      }
    }
    else if(i.target.value ==='Select Adverse Criteria'){
      setAEClassification('')

    }
    }
const [inputTextNotes, setInputTextNotes] = useState('')
const handleAesiInputText=(e)=>{
  let value = e.target.value;
      if(caseDef === EVENT_CLASSIFICATION_AESI){
      const updatedObject = {
        ...eventDesc,
        event_description_id: studyAeDtls[0]?.other_case?.study_aesi_description_id
      };
      setEventDesc(updatedObject)
    }

       if(value!==''){
        setInputTextNotes(value)
       }else{setInputTextNotes('')}
    }
    const handleTreatment=(e)=>{
      let value = e.target.value;
       if(value!==''){ setTreatmentGiven(value)}
       else{setTreatmentGiven('')}
       
    }
 
const [concomitantMedication, setConcomitantMedication]= useState('no')
    const handleOptionChange = (e) => {
      setSelectedOption(e.target.value);
   // setConcomitantMedication(e.target.value)
    };
    const [bmiMessage, setBmiMessage] = useState('');
    
    const calculateBMI = (weight, height) => {
      if (weight && height) {
        const weightKg = parseFloat(weight);
        const heightM = parseFloat(height) / 100; // Convert height to meters
        const bmiValue = (weightKg / (heightM * heightM)).toFixed(1);
        setBMI(bmiValue);
        let message = '';
        if (bmiValue < 18.5) {
            message = ' Underweight';
        } else if (bmiValue >= 18.5 && bmiValue < 25) {
            message = 'Normal weight';
        } else if (bmiValue >= 25 && bmiValue < 30) {
            message = 'Overweight';
        } else {
            message = 'Obese';
        }
        setBmiMessage(message);
      } else {
        setBMI('');
        setBmiMessage('');
      }
    };
    const [timeError1, setTimeError1] = useState("");
  const [showTimeError1, setShowTimeError1] = useState(false)

  function validateTimeOfOnset1(event) {
    const inputTime = event.target.value;
    const timeOfOnset = timeOfAdministration;
  
    if (timeOfOnset) {
      
      // Convert input times to minutes for comparison
      const inputTimeMinutes = timeStringToMinutes1(inputTime);
      const timeOfOnsetMinutes = timeStringToMinutes1(timeOfOnset);
  
      if (inputTimeMinutes < timeOfOnsetMinutes) {
        const val = "Select time after "+timeOfAdministration
        setTimeError1(val)
        setShowTimeError1(true)
        // If the input time is before the time of onset, clear the input
        event.target.value = '';
      }
      else{
        setTimeError1("val")
        setShowTimeError1(false)
      }
    }
  }
  
  
  function timeStringToMinutes1(timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  }


const [concomitantRadio, setConcomitantRadio] = useState('no')
const [medUsedInLast3WeeksRadio, setMedUsedInLast3WeeksRadio] = useState('no')

const [searchTerm, setSearchTerm] = useState("");
const handleConcomitantRadio=(e)=>{
    setConcomitantRadio(e.target.value)
    if(e.target.value =='no'){
        setConcomitantRadio(e.target.value)
     medicationDetails.forEach(obj => {
            for (const key in obj) {
              obj[key] ='';  
            }
          });
          setMedicationDetails(medicationDetails)

    }
}

const handleMedUsedInLast3WeeksRadio=(e)=>{
  setMedUsedInLast3WeeksRadio(e.target.value)
  if(e.target.value =='no'){
    setMedUsedInLast3WeeksRadio(e.target.value)
   medicationDetails.forEach(obj => {
          for (const key in obj) {
            obj[key] ='';  
          }
        });
        setMedicationDetails(medicationDetails)

  }
}

      const maskedAadhar = piDetails?.aadhar_card_number?.slice(0, -4).replace(/\d/g, '*') + piDetails?.aadhar_card_number?.slice(-4);

    const handleInputChange = (index, e) => {
        const { name, value } = e.target;
        const newArray = [...medicationDetails];
        newArray[index][name] = value;
        setMedicationDetails(newArray);
        if(concomitantRadio =='no'){
            setMedicationDetails([]);
        }
      };

      const handleInputMedicationUsedChange = (index, e) => {
        const { name, value } = e.target;
        const newArray = [...medUsedInLast3WeeksDetails];
        newArray[index][name] = value;
        setMedUsedInLast3WeeksDetails(newArray);
        if(medUsedInLast3WeeksRadio =='no'){
            setMedUsedInLast3WeeksDetails([]);
        }
      };
      const [currentIndex, setCurrentIndex] = useState(1);

      const handleAddFields = () => {
        setMedicationDetails([...medicationDetails, 
            {
                "medication": "",
                "medication_manufacturer": "",
                "medication_batch_number": "",
                "medication_route_site": "",
                "medication_dosage":"",
                "medication_frequency": "",
                "current_idx":currentIndex+1
            },]);
            setCurrentIndex(currentIndex + 1);
      };

      const handleAddMedUsedInLast3WeeksFields = () => {
        setMedUsedInLast3WeeksDetails([...medUsedInLast3WeeksDetails, 
            {
                "medication_name": "",
                "medication_route": "",
                "dosage":"",
                "frequency": "",
                "current_idx":currentIndex+1
            },]);
            setCurrentIndex(currentIndex + 1);
      };

      const handleDeleteFields = (index) => {
        let updatedData = [...medicationDetails]
        updatedData?.map((elemObj,i)=>{
          if(elemObj.current_idx==index.current_idx){
            updatedData.splice(i,1)
          }
        })

        
        setMedicationDetails(updatedData)
      }

      const handleDeleteMedicationUsed =(index) => {
        let updatedData = [...medUsedInLast3WeeksDetails]
        updatedData?.map((elemObj,i)=>{
          if(elemObj.current_idx==index.current_idx){
            updatedData.splice(i,1)
          }
        })

        
        setMedUsedInLast3WeeksDetails(updatedData)
      }

      const selectedStudy = (id, option)=>{
         if(id){
            setStudy_id(id)
        }
      }
    useEffect(() => {
        
    const currentDate = new Date();
    const formattedDate = currentDate.toDateString();
    setToday(formattedDate);
    }, []);
    const handleStepChange = (val) => {
        if(val > 0 && regStep < registrationSteps.length + 1){
            let shift = regStep + val
            setRegStep(shift);
        }
        if(val < 0 && regStep > 1){
            let shift = regStep + val
            setRegStep(shift);
        }
        
    }
 
    const handleQrGenderChange = (val) => {
        setGender(val);
        };
 
  const [fifthInputs, setFifthInputs] = useState({
    date_of_onset:'',
    time_of_onset:'',
    causality_id:'',
    action_taken_for_ae:'',
    outcome_id:'',
    action_taken_id:'',

        })
const [treatFlag, setTreatFlag] = useState(Boolean)


const [selectedAction, setSelectedAction] = useState()


const handleAeOptions = (e) => {
  const { name, value } = e.target;
  if(name==='action_taken_for_ae'){setSelectedAction(e.target.options[e.target.selectedIndex].innerHTML)}
  const selectedValue = e.target.value;
    let flagValue = true;
    if (name === "action_taken_for_ae") {
      setStartDate('')
      setEndDate('')
      if (selectedValue === "Select") {
        flagValue = true;
        setNewFlag("None");
      } else {
        for (var i = 0; i < actionTakenforAe.length; i++) {
          var currentObject = actionTakenforAe[i];
          if (currentObject.action_taken_for_adverse_event_id === value) {
            setActionAdverse(currentObject.action_taken_for_adverse_event_name);
            if (currentObject.action_taken_for_adverse_event_name === "None") {
              flagValue = true;
              setNewFlag(currentObject.action_taken_for_adverse_event_name)
            } else {
              setNewFlag(currentObject.action_taken_for_adverse_event_name)
              flagValue = false;
            }
          }
        }
      }
    // } else if (
    //   name === "causality_id" ||
    //   name === "outcome_id" ||
    //   name === "action_taken_id"
    // ) {
    //   // Check for specific values of newFlag
    //   if (newFlag === "Surgical Treatment" || newFlag === "Medical Treatment") {
    //     flagValue = false;
    //   } else {
    //     flagValue = true;
    //   }
    }
    setChoosenOption(selectedValue);
  if (
    name === "causality_id" ||
    name === "outcome_id" ||
    name === "action_taken_id" ||
    name === "action_taken_for_ae"
  ) {
    if(flag===false){
  
      flagValue=false
    } 
    if (value !== "Select") {
      setFifthInputs((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      setFifthInputs((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  }else {
    if(flag===false){
      
      flagValue=false
    } 
    
    setFifthInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (newFlag === "Surgical Treatment" || newFlag === "Medical Treatment") {
      flagValue = false;
    } else {
      flagValue = true;
    }
  }
  // Set the flag value
  setFlag(flagValue);

if(name==="date_of_onset"){
  setDateOfResolution('')
  setTimeOfResolution('')
  setStartDate('')
  setEndDate('')
}
 

};

const [firstPgInputs, setFirstPgInputs] = useState({
  first_name:'',
  last_name:'',
  date_of_birth:''
})

const handleFirstPage =(e)=>{
   e.preventDefault()
  const { name, value } = e.target;
  const regex = /^[A-Za-z\s.]+$/; // Only alphabetic characters allowed
  const regexw = /^[0-9]+(\.[0-9]+)?$/;
  if (name === "date_of_birth") {
    calculateAge(value)
  }


  if(name==='first_name' || name ==='last_name'){
    if (regex.test(value) || value === '') {
      setFirstPgInputs((prev =>({
        ...prev,
        [name]:value,
      })))
    }
  }
  else{setFirstPgInputs((prev =>({
    ...prev,
    [name]:value,
  })))}

}
 

const firstDisable = Object.keys(firstPgInputs)
.map((key) => firstPgInputs[key])
.every((value) => value !== '');

const fifthDisable = Object.keys(fifthInputs)
.map((key) => fifthInputs[key])
.every((value) => value !== '');
 
    const handleWeightChange = (e) => {
      const{value} = e.target;
      const regex = /^[+]?([0-9]+(?:[\.][1-9]*)?|\.[1-9])$/;
     
      if ((regex.test(value) || value === '') && parseFloat(value) <= 250) {
        let sliceddata = value.split('.')[1] 
        setWeight(value)
        calculateBMI(value, height);
        setWerror1(null);
      } else if (e.nativeEvent.inputType === "deleteContentBackward") {
        const truncatedValue = value.slice(0, -1); 
        setWeight(value)
        calculateBMI(value, height);
        setWerror1(null);
      } else if(value.length>3){
        setWerror1(null)
      }else {
        setWerror1("Weight cannot exceed 250kg");
      
      }
       
    }
    const handleHeightChange = (e) => {
      const{value} = e.target;
      const regex = /^[+]?([0-9]+(?:[\.][1-9]*)?|\.[1-9])$/;
       if ((regex.test(value) || value === '') && parseFloat(value) <= 250) {
        setHeight(value);
        calculateBMI(weight, value);
        setError1(null);
      } else if (e.nativeEvent.inputType === "deleteContentBackward") {
        const truncatedValue = value.slice(0, -1); 
        setHeight(truncatedValue);
        calculateBMI(weight, truncatedValue);
        setError1(null);
      } else {
        setError1("Height cannot exceed 250cm");
      
      }
       
    }

   

    const calculateAge = (dateOfBirth) => {
        const today = new Date();
        const birthDate = new Date(dateOfBirth);
        let calculatedAge = today.getFullYear() - birthDate.getFullYear();
    
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() &&
            today.getDate() < birthDate.getDate())
        ) {
            calculatedAge--;
        }
    
        setAge(calculatedAge);
        };
    
window.onkeydown = keypress;
function keypress(event) {
    if (event.keyCode == 27) {
        setShowPopup(false);
    }
}
function handleOption(e) {
  setSearchTerm(e.serious_adverse_event_name);
  setShowPopup(false)
  setBtnTitle(e.serious_adverse_event_name)
  setSeriousAE({
    label: e.serious_adverse_event_name,
    value: e.serious_adverse_event_id,
  })
}
const handleNavigateNext =()=>{
    if(study_id.length===0){toast.error('Select a study to continue', {toastId: 1})
        
      }
    if(study_id.length!==0){handleStepChange(1)}
}

const dosesArray = Array.from({ length: optedStudy?.number_of_doses-optedStudy?.number_of_doses+1}, (idx, i) => i + 1);
const currentDate = new Date();
const range = optedStudy && optedStudy?.age_group?.split('-');
const minDateOfBirth = new Date(currentDate);
const maxDateOfBirth = new Date(currentDate);
let minDob, maxDob
if(range)
 {
  minDateOfBirth.setFullYear(currentDate.getFullYear() - range[1]);
  maxDateOfBirth.setFullYear(currentDate.getFullYear() - range[0]);
  // minDob = minDateOfBirth.toISOString().split('T')[0]
  // maxDob = maxDateOfBirth.toISOString().split('T')[0]
}

const [eventDesc, setEventDesc] = useState()
const [valuForDisble, setValuForDisble] = useState()

function getEventDescId(val){
  if(val){
    setEventDesc(val)
    setValuForDisble(val)
    }
    
}

const handleClosePopup = () => {
  setOpen(false);
  navigate('/pisubjectslist')
  setTimeout(() => {
    window.location.reload();
    
  }, 200);
};
const handleReviewActions = () => {
  setOpen(false);
  navigate('/pisubjectslist')
  setTimeout(() => {
    window.location.reload();
    
  }, 200);
}

 
 
let currentTime = `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
const [isbtnDisabled, setIsbtnDisabled] = useState(false);
const handelSubjectCreate =()=>{
  if(medUsedInLast3WeeksDetails[0].medication_name===""){
    medUsedInLast3WeeksDetails=[];
  }
  let objForSubject = {
    "study_id": study_id[0] === '' ? null : study_id[0],
    "pi_id": localStorage.pi_id || null,
    "first_name": firstPgInputs.first_name === '' ? null : firstPgInputs.first_name,
    "last_name": firstPgInputs.last_name === '' ? null : firstPgInputs.last_name,
    "date_of_birth": firstPgInputs.date_of_birth === '' ? null : firstPgInputs.date_of_birth,
    "sex": gender === '' ? null : gender,
    "date_of_report": today || null,
    "weight": weight === '' ? null : weight,
    "height": height === '' ? null : height,
    "phone_number": subjPhone === '' ? null : subjPhone,
    "city_id": piSiteDetails?.city_id || null,
    "state_id": piSiteDetails?.state_id || null,
    "zone_id": piSiteDetails?.zone_id || null,
    "site_id": piSiteDetails?.site_id || null,
    "site_code": piSiteDetails?.site_code || null,
    "dose": dose === '' ? null : dose,
    "allergies": anyAllergies === '' ? null : anyAllergies,
    "medication_used_in_last_3weeks": medicationsUsed === '' ? null : medicationsUsed,
    "medical_history": medicalHistory === '' ? null : medicalHistory,
    "concurrent_illness": ConcurrentIllness === '' ? null : ConcurrentIllness,
    "date_of_administration": dateOfAdministration === '' ? today :dateOfAdministration,
    "time_of_administration": timeOfAdministration === '' ? currentTime : timeOfAdministration,
    "route_of_administration": optedStudy?.dose_of_administration || null,
    "anatomical_site_of_administration": optedStudy?.anatomical_site_administration || null,
    "batch_number": batchNumber === '' ? null : batchNumber,
    "expiry_date": expiry === '' ? null : expiry,
    "date_of_manufacture": dateOfManu === '' ? null : dateOfManu,
    "is_ae_with_in_30mins": selectedOption == 'yes' ? TOGGLE_YES : TOGGLE_NO,
    "is_concomitant_medication": concomitantRadio == 'yes' ? TOGGLE_YES : TOGGLE_NO,
    "study_aebank_id": eventDesc?.study_aebank_id || null,
    "study_case_definition": caseDef === '' ? null : caseDef,
    "is_case_meets": eventDesc?.is_case_meets || null,
    "event_description_id": eventDesc?.event_description_id || null,
    "date_of_onset": fifthInputs.date_of_onset === '' ? null : fifthInputs.date_of_onset,
    "time_of_onset": fifthInputs.time_of_onset === '' ? null : fifthInputs.time_of_onset,
    "date_of_resolution": dateOfResolution === '' ? null : dateOfResolution || null,
    "time_of_resolution": timeOfResolution === '' ? null : timeOfResolution,
    "causality_id": fifthInputs.causality_id || null,
    "action_taken_for_adverse_event_id": fifthInputs.action_taken_for_ae || null,
    start_date_of_treatment:startDate==="" ? null : startDate,
    end_date_of_treatment:endDate==="" ? null : endDate,
    "outcome_id": fifthInputs.outcome_id || null,
    "action_taken_id": fifthInputs.action_taken_id || null,
    "any_treatment_given": treatmentGiven === '' ? null : treatmentGiven,
    "is_serious_adverse_event": toggleSAE ? TOGGLE_YES : TOGGLE_NO || null,
    "serious_adverse_event_id": seriousAE?.value || null,
    "is_medication_usedinlast3weeks" : medUsedInLast3WeeksRadio ? TOGGLE_YES : TOGGLE_NO || null,
    "medication_usedinlast3weeks" : medUsedInLast3WeeksDetails  === '' ? null : medUsedInLast3WeeksDetails,
    "concomitant_medication": medicationDetails === '' ? null : medicationDetails,
    "created_by": piDetails?.name || null,
    // "date_of_onset_sae": dateofOnsetSAE === '' ? null : dateofOnsetSAE,
    "input_notes_aesi_others": inputTextNotes === '' ? null : inputTextNotes || null,
  };
   const isSubmitBtnDisabled = Object.keys(objForSubject)
    .filter((i) => i !== 'date_of_onset_sae')
    .map((key) => objForSubject[key])
    .every((value) => value !== '');

  const formData = new FormData();
  for (const key in objForSubject) {
    if(objForSubject[key]!== null){
      if(key == 'concomitant_medication')
        formData.append(key, JSON.stringify(objForSubject[key]));
      else if(key == 'medication_usedinlast3weeks')
        formData.append(key, JSON.stringify(objForSubject[key]));
      else  
        formData.append(key, objForSubject[key]);
    }
      
  }
  for (let i = 0; i < file.length; i++) {
    formData.append('files', file[i]);
  }
    setIsbtnDisabled(true)
    setLoading(true);
    axios
    .post(base_url + 
      "subjects/create_subject", formData,{
         headers: {
        'Content-Type': 'multipart/form-data'
    }})
    .then((res) => {
      setIsbtnDisabled(false)
      setLoading(false);
      if(res.data.message ==='Subject Created'){
      setOpen(true) }
      else{
        alert('Some thing went wrong')
        setTimeout(() => {
          window.location.reload()
          navigate('/pisubjectslist')
        }, 500);
      }
    

    }) .catch((error) => {
      setIsbtnDisabled(false)
      setLoading(false);
         console.log(error)
      });
    
  }
  

 
 const handlePhonenumber=(e)=>{
  let value= e.target.value
  
    setSubjPhone(value.length>10?value.slice(0,10):value)
    setPhoneValidation(value.length>=10? true :false)
    // setError(value.length === 10 || value.length === 0 ? '' : 'Must be 10 digits');
    if (value.length <= 10) {
      setSubjPhone(value);
      setError(value.length === 10 || value.length === 0 ? '' : '* Must be 10 digits');
    }
 }
 
  const maxDate = new Date().toISOString().split('T')[0];
  const minDate = fifthInputs.date_of_onset && new Date(fifthInputs.date_of_onset).toISOString().split('T')[0];
  const JustBtwn = "d-flex justify-content-between";
  const next = "orange_btn px-4 orange_btn_mbl";
    
const [subjRejFun, setSubjRejFun] = useState(false)

useEffect(() => {
 if(window.location.pathname==='/subjectregistration' && window.screen.width<=720){
  setSubjRejFun(true)
}else{
   setSubjRejFun(false)

 }
}, [window.location.pathname , ])
function handleBackAction() {
  handleStepChange(-1)
}
function handleExitSubRej() {
  navigate('/pisubjectslist')
}

const handleStartDateChange = (e) => {
  setStartDate(e.target.value);
  setEndDate('')
};

const handleEndDateChange = (e) => {
  const selectedEndDate = e.target.value;
  if (selectedEndDate < startDate) {
    return;
  }
  if(startDate){
  setEndDate(selectedEndDate);}
};

const [timeError, setTimeError] = useState("");
  const [showTimeError, setShowTimeError] = useState(false)

  function validateTimeOfResolution(event) {
    const inputTime = event.target.value;
    const timeOfOnset = fifthInputs.time_of_onset;
  
    if (timeOfOnset) {
      // Convert input times to minutes for comparison
      const inputTimeMinutes = timeStringToMinutes(inputTime);
      const timeOfOnsetMinutes = timeStringToMinutes(timeOfOnset);
  
      if (inputTimeMinutes < timeOfOnsetMinutes) {
        const val = "Select time after "+fifthInputs.time_of_onset
        setTimeError(val)
        setShowTimeError(true)
        // If the input time is before the time of onset, clear the input
        event.target.value = '';
      }
      else{
        setTimeError("val")
        setShowTimeError(false)
      }
    }
  }
  
  
  function timeStringToMinutes(timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave? Your data may be lost.";
      event.returnValue = message; // Standard for most browsers
      return message; // For some older browsers
    };

    const startListener = () => {
      window.addEventListener('beforeunload', handleBeforeUnload);
    };

    const stopListener = () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };

    // Start listener when component mounts
    startListener();

    // Stop listener when component unmounts
    return () => {
      stopListener();
    };
  }, []);


  return (
    <>
     <div>
      <NavigationBar
        title={"New Subject"}
        selectedStudy={selectedStudy}
        btnDisable={btnDisable}
      />
   {/* <PIFlowLeftNavBar /> */}
      <div className="main_body registration_steps_main" >
        <div className="row">
          <div
            className="col-lg-3 reg_stps_titlbar"
            style={{
              backgroundColor: "#E2E8F0",
            }}
          >
            <div className="lableSteps regstep_title">
            
              <span className='regstpstxtmbl'>
              <img src="./images/icons/back_arrow.svg" alt="" 
              onClick={handleBackAction}
              className='back_arrowmbl'/>&nbsp; 
              Registration Steps</span>
              <span>{regStep + " of " + registrationSteps.length}</span>
            </div>
            <div className='subj_reg_mbl' style={{ maxHeight: "66vh", overflowY: "auto" }}>
              {registrationSteps.map((step, index) => {
                return (
                  <div
                  key={index}
                    className={`${
                      regStep === index + 1 ? "selectedTabStyl" : ""
                    }`}
                  >
                    <div
                      className={`my-div ${
                        regStep === index + 1
                          ? "registration_steps_selected selectdMr"
                          : "registration_steps"
                      }`}
                      key={index}
                    >
                      <span>{step.stepTitle}</span>
                      <span className="registration_description">
                        {step.description}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col">
            <div className="lableContent top-stepper-main subj_reg_mbl">
              <div className="regStepsMain ">
                {registrationSteps.map((item, index) => (
                  <div
                  key={index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div
                        className={`${
                          regStep >= index + 1 ? "stageSelected" : "stage"
                        }`}
                      >
                        <span>{index + 1}</span>
                      </div>
                    </div>
                    
                  </div>
                ))}
              </div>
            </div>
            {regStep === 1 && (
              <div className="subject_reg_body subjregmbl">
                <div className='row d-flex gap-2 gap-md-4 mt-0 '>
              <div>

                
              </div>
                 <div className="col-12 col-md-6 col-lg-6 col-xxl-6">
                    <label htmlFor="mrName">
                      First name<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={firstPgInputs.first_name || rejSubj?.first_name}
                      autoFocus
                      disabled={dsblFrRejSub}
                      name="first_name"
                      className="customInput"
                      id="firstName"
                      type="text"
                      inputMode="text"
                      placeholder="First name"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleFirstPage}
                      // onKeyDown={(e) => {
                      //   const key = e.key;
                      //   // Allow only alphabetic characters
                      //   if(!/^[a-zA-Z\s.]+$/.test(key)){
                      //     e.preventDefault();
                      //   }
                      // }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^a-zA-Z\s.]/g, ''); // Allow only alphabetic characters, spaces, and periods
                      }}
                     
                    />


                  </div>
                    
                  <div className= 'col-lg'>
                      <label htmlFor="lastName">
                        Last name<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={firstPgInputs.last_name || rejSubj?.last_name}
                        name="last_name"
                        disabled={dsblFrRejSub}
                        className="customInput"
                        id="lastName"
                        type="text"
                        placeholder="Last name"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "10px 12px", width: "380px" }}
                        onChange={handleFirstPage}
                        // onKeyDown={(e) => {
                        //   const key = e.key;
                        //   // Allow only alphabetic characters
                        //   if (!/^[a-zA-Z\s.]+$/.test(key)) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^a-zA-Z\s.]/g, ''); // Allow only alphabetic characters, spaces, and periods
                        }}
                      />
                  </div>
                    <div className="col col-md-6 col-lg-6  dateOfBirth">
                      <label htmlFor="dateOfBirth">
                        Date of Birth<span style={{ color: "red" }}>*</span>
                      </label>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <input
                          style={{
                            borderRadius: "6px 0px 0px 6px",
                            padding: "10px 12px",
                            width: "190px",
                            cursor: "not-allowed",
                          }}
                          value={firstPgInputs.date_of_birth || rejSubj?.date_of_birth}
                          max={moment(maxDateOfBirth).format('YYYY-MM-DD')||minDob}
                          min={moment(minDateOfBirth).format('YYYY-MM-DD')||maxDob}
                          disabled={dsblFrRejSub}
                          //min="1920-01-01"
                          name="date_of_birth"
                          className="customInput dateOfBirth"
                          id="dateOfBirth"
                          type="date"
                          aria-placeholder="#D4D4D4"
                          onChange={handleFirstPage}
                          onKeyDown={(e) => e.preventDefault()} // Prevent user input
                        />
                        <input  style={{
                            borderRadius: "0px",
                            padding: "10px 12px",
                            width: "140px",
                          }}
                          value={age}
                          className="ageFieldmbl"
                          id="mrAge"
                          type="number"
                          placeholder="Age"
                          aria-placeholder="#D4D4D4"
                          disabled
                        />
                        <input
                          value={"Yrs"}
                          className="years"
                          id="mrAge"
                          type="text"
                          placeholder="Yrs"
                          aria-placeholder="#D4D4D4"
                          style={{
                            padding: "10px 12px",
                            width: "50px",
                            borderRadius: "0px 8px 8px 0px",
                            backgroundColor: "#F7F9FB",
                          }}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col">
                      <label htmlFor="mrGender">
                        Sex<span style={{ color: "red" }}>*</span>
                      </label>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        {["Male", "Female", "Others"].map((option) => { 
                        let selectedGender = rejSubj?.sex === option

                          
                          return(
                          <button
                            key={option}
                            disabled={dsblFrRejSub}
                            onClick={() => handleQrGenderChange(option)}
                            className={`genderButton ${
                              gender === option ? "genderButtonSelected" : ""
                            }`}
                            style={{
                              borderRadius:
                                option === "Male"
                                  ? "6px 0px 0px 6px"
                                  : option === "Others"
                                  ? "0px 6px 6px 0px"
                                  : "0px",
                            }}
                          >
                            {option}
                          </button>
                        )})}
                      </div>
                    </div>

                 
                 
                 

                  <div className="col-12 col-md-6">
                    <label htmlFor="weight">
                      Weight<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex" }} className='weight_input'>
                      <input
                        value={weight || rejSubj?.weight}
                        disabled={dsblFrRejSub}
                        className=" "
                        name="weight"
                        id="weight"
                        inputMode='decimal'
                        placeholder="Enter weight"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "10px 12px",
                          width: "329px",
                          borderRadius: "8px 0px 0px 8px",
                        }}
                        onChange={handleWeightChange}
                        // onKeyDown={(e) => {
                        //   const key = e.key;
                        //   // Allow only positive numbers, spaces, and periods
                        //   if (!/^[0-9.\s]+$/.test(key) && key !== "Backspace" && key !== "Delete") {
                        //     e.preventDefault();
                        //   }
                        // }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^\d.\s]/g, ''); // Allow positive integers, dots, and spaces
                      }}
                      
                        
                      />
                    
                      <input
                        value={"kg"}
                        className=""
                        id="weight_in_KG"
                        type="text"
                        placeholder="KG"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "10px 12px",
                          width: "50px",
                          borderRadius: "0px 8px 8px 0px",
                          backgroundColor: "#F7F9FB",
                        }}
                        disabled
                      />
                    </div>
                    {werror && <div style={{ color: 'red' }}>{werror}</div>}
                  </div>
                 
                  <div className="col">
                    <label htmlFor="Phone_code">
                      Phone<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex" }} className='phone_input'>
                    <input
                        value={"+91"}
                        className=""
                        id="Phone_code"
                        type="text"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "10px 7px",
                          width: "50px",
                          borderRadius: "8px 0px 0px 8px",
                          backgroundColor: "#F7F9FB",
                        }}
                        disabled
                      />
                      <input
                        value={
                        subjPhone.length>=10?subjPhone.slice(0,10):subjPhone || rejSubj?.phone_number
                      }
                        disabled={dsblFrRejSub}
                        className=" noSpinArrows"
                        name="phone_number"
                        id="phone_number"
                        type="number"
                        placeholder="Enter phone number"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "10px 12px",
                          width: "329px",
                          borderRadius: "0px 8px 8px 0px",
                        }}
                        onChange={handlePhonenumber}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^\d\s]/g, ''); // Allow only positive integers and spaces
                        }}
                      />
                     
                    </div>
                    <div className=' ' style={{ color: 'red' }}>{error}</div>
                  </div>
                 
                 
                  {/* <div className="col-12 col-md-6">
                    <label htmlFor="mrName">Phone<span className="text-danger">*</span></label>
                    <div style={{ display: "flex" }} className='col-12 ' >
                    <input
                        value={"+91"}
                        className=""
                        id="lastName"
                        type="text"
                        placeholder="+91"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "10px 12px",
                          width: "52px",
                          borderRadius: "8px 0px 0px 8px",
                          backgroundColor: "#F7F9FB",
                        }}
                        disabled
                      />
                    <input
                      value={
                        subjPhone.length>=10?subjPhone.slice(0,10):subjPhone || rejSubj?.phone_number
                      }
                      className="customInput noSpinArrows ph_input "
                      name="phone_number"
                      disabled={dsblFrRejSub}
                      id="phone_number"
                      type="number"
                      placeholder="Enter phone number"
                      aria-placeholder="#D4D4D4"
                      style={{
                        padding: "10px 12px",
                         
                        borderRadius: "0px 8px 8px 0px",
                      }}
                      onChange={handlePhonenumber}
                    />
                    </div>
                    <div className=' ' style={{ color: 'red' }}>{error}</div>
                  </div>
                   */}

                  <div className="col-12 col-md-6">
                    <label htmlFor="height">
                      Height<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex" }} className='weight_input'>
                      <input
                        value={height || rejSubj?.height}
                        disabled={dsblFrRejSub}
                        className=" "
                        name="height"
                        id="height"
                        inputMode='decimal'
                        placeholder="Enter height"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "10px 12px",
                          width: "329px",
                          borderRadius: "8px 0px 0px 8px",
                        }}
                        onChange={handleHeightChange}
                        // onKeyDown={(e) => {
                        //   const key = e.key;
                        //   // Allow only positive numbers, spaces, and periods
                        //   if (!/^[0-9.\s]+$/.test(key) && key !== "Backspace" && key !== "Delete") {
                        //     e.preventDefault();
                        //   }
                        // }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^\d\s.]/g, ''); // Allow positive integers, dots, and spaces
                      }}
                      
                      />
                      <input
                        value={"cm"}
                        className=""
                        id="CM"
                        type="text"
                        placeholder="CM"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "10px 12px",
                          width: "52px",
                          borderRadius: "0px 8px 8px 0px",
                          backgroundColor: "#F7F9FB",
                        }}
                        disabled
                      />
                    </div>
                    {error1 && <div style={{ color: 'red' }}>{error1}</div>}
                  </div>

                  <div className="col-12 col-md">
                    <label htmlFor="mrName">Date of enrollment</label>
                    <input
                      value={today + " (Today)" || rejSubj?.date_of_report}
                      className="customInput date_of_report"
                      name="date_of_report"
                      id="date_of_report"
                      type="text"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      disabled
                    />
                  </div>
                </div>
                

              <div className="col-12 col-md-6">
                    <label htmlFor="bmi">
                      BMI
                    </label>
                    <div style={{ display: "flex" }} className=''>
                      <input
                        value={bmi}
                        disabled
                        className="Bmi_input"
                        name="bmi"
                        id="bmi"
                        type="text"
                        placeholder="BMI"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "10px 12px", width: "380px" }}
                        onChange={handleHeightChange}
                      />
                    </div>
                  
                    <div className="result">
                  <p>
                    <span className={bmiMessage === "Normal weight" ? "text-success" : "text-danger"}>
                      {bmiMessage}
                    </span>
                  </p>
                </div>

        
                  </div>

                </div>
            )}
            {regStep === 2 && (
              <div className="subject_reg_body pt-0  ">
                <div className='d-flex row g-2 g-md-4 g-lg-4 g-xxl-4 mt-0 gap-2 gap-md-0 gap-lg-0 gap-xxl-0 justify-content-between pb-2 pb-md-0 pb-lg-0 '>
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="city">City</label>
                    <input
                      value={piSiteDetails?.city_name}
                      className="customInput"
                      name="city_id"
                      id="city"
                      type="text"
                      placeholder="Hyderabad"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      onChange={handleCity1Change}
                      disabled
                    />
                  </div>
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="state">State </label>
                    <input
                      value={piSiteDetails?.state_name}
                      className="customInput"
                      name="city_id"
                      id="state"
                      type="text"
                      placeholder="Hyderabad"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      onChange={handleCity1Change}
                      disabled
                    />
                  </div>

                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="city">Zone</label>
                    <input
                      value={piSiteDetails?.zone_name}
                      className="customInput"
                      id="city"
                      type="text"
                      placeholder="TH0001"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                

                
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="city">Site Name</label>
                    <input
                      value={piSiteDetails?.site_name}
                      className="customInput"
                      id="city"
                      type="text"
                      placeholder="TH0001"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="city">Site Code</label>
                    <input
                      value={piSiteDetails?.site_code}
                      className="customInput"
                      id="city"
                      type="text"
                      placeholder="TH0001"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="city">Subject Number</label>
                    <input
                      value={subjNumber?.sequence_number}
                      className="customInput"
                      id="city"
                      type="number"
                      placeholder=""
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      onChange={handleSubjectNumberChange}
                      disabled
                    />
                  </div>
                  
                
                 
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piName">PI Name</label>
                    <input
                      value={piDetails?.name}
                      className="customInput"
                      id="piName"
                      type="text"
                      placeholder="Full name"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piContactNumber">PI Contact Number</label>
                    <input
                      className="customInput noSpinArrows"
                      value={piDetails?.contact_number}
                      id="piContactNumber"
                      type="number"
                      placeholder="9922112233"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                     
                  </div>
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piEmail">PI Email</label>
                    <input
                      className="customInput"
                      value={piDetails?.email}
                      id="piEmail"
                      type="email"
                      placeholder="email@gmail.com"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                 
                 
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piGender">Gender</label>
                    <input
                      className="customInput"
                      value={piDetails?.gender}
                      id="piGender"
                      type="text"
                      placeholder="Male"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piAddressLane1">Address Line 1</label>
                    <input
                      className="customInput"
                      value={piDetails?.address}
                      id="piAddressLane1"
                      type="text"
                      placeholder="Kaveri hills"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piCountry">Country</label>
                    <input
                      className="customInput"
                      value={piDetails?.country}
                      id="piCountry"
                      type="text"
                      placeholder="India"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                
                 
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piState">State</label>
                    <input
                      className="customInput"
                      value={piDetails?.state}
                      id="piState"
                      type="text"
                      placeholder="Telangana"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piDistrict">District</label>
                    <input
                      className="customInput"
                      value={piDetails?.district}
                      id="piDistrict"
                      type="text"
                      placeholder="Hyderabad"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piCity">City</label>
                    <input
                      className="customInput"
                      value={piDetails?.city}
                      id="piCity"
                      type="text"
                      placeholder="Hyderabad"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                 
                
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piPincode">Pincode</label>
                    <input
                      className="customInput noSpinArrows"
                      value={piDetails?.pin_code}
                      id="piPincode"
                      type="number"
                      placeholder="500081"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                     
                  </div>
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piNationality">Nationality</label>
                    <input
                      className="customInput"
                      value={piDetails?.nationality}
                      id="piNationality"
                      type="text"
                      placeholder="Indian"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piAadhar">Aadhar Card Number</label>
                    <input
                      className="customInput"
                      value={maskedAadhar}
                      id="piAadhar"
                      type="text"
                      placeholder="1234 5678 9012"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                     
                  </div>
                 
                 
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piIdType">ID Proof Type</label>
                    <input
                      className="customInput"
                      value={piDetails?.id_proof_type}
                      id="piIdType"
                      type="text"
                      placeholder="PAN"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-sm-6 col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piMciNumber">MCI Registration Number</label>
                    <input
                      className="customInput"
                      value={piDetails?.mci_registration_number}
                      id="piMciNumber"
                      type="text"
                      placeholder="650001"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                  <div className="col col-lg-4 col-md-4 subj_input">
                    <label htmlFor="piOtherEmail">Other Email Address</label>
                    <input
                      className="customInput"
                      value={piDetails?.other_email}
                      id="piOtherEmail"
                      type="email"
                      placeholder="email@gmail.com"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px" }}
                      disabled
                    />
                  </div>
                
              </div>
              </div>
            )}
            {regStep === 3 && (
              <div className="subject_reg_body">
                <div className={`row mt-0 gap-3 ${JustBtwn}`}>
                  <div className="col-6 col-lg-5 allergies">
                    <label htmlFor="mrName">
                      Any allergies
                    </label>
                    <input
                      value={anyAllergies}
                      className="customInput"
                      id="firstName"
                      type="text"
                      placeholder="Enter here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleAllergyChange}
                    />
                  </div>

            
                 
                  <div className="col-6 col-lg-5 allergies">
                    <label htmlFor="mrName">
                    Medical history
                    </label>
                    <input
                      value={medicalHistory}
                      className="customInput"
                      id="firstName"
                      type="text"
                      placeholder="Enter here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleMedicalHistoryChange}
                    />
                  </div>

                  <div className="col-6 col-lg-5 allergies">
                    <label htmlFor="concurrent_ill">
                      Concurrent illness(if any) specify
                    </label>
                    <input
                      value={ConcurrentIllness}
                      className="customInput"
                      id="concurrent_ill"
                      type="text"
                      placeholder="Enter here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleConcurrentIllnessChange}
                    />
                  </div>

                  {/* <div className="subject_reg_body"> */}
                <div>
                  <div className="">
                    <label htmlFor="mrName">
                      Any medication used in last 3 weeks?
                    </label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="radio"
                          value="yes"
                          checked={medUsedInLast3WeeksRadio === "yes"}
                          onChange={handleMedUsedInLast3WeeksRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Yes</span>
                      </label>

                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          value="no"
                          checked={medUsedInLast3WeeksRadio === "no"}
                          onChange={handleMedUsedInLast3WeeksRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>No</span>
                      </label>
                    </div>
                  </div>
                </div>
                {medUsedInLast3WeeksRadio === "yes" && (
                  <div className="concomitant_container">
                    <Row className="mt-0 ps-2 ps-md-0">
                      {medUsedInLast3WeeksDetails?.map((input, index) => (
                        <div
                          key={input.id}
                          className="position-relative concomitant_detials px-3 mt-4"
                        >
                          {index !== 0 && (
                            <button
                              onClick={() => handleDeleteMedicationUsed(input, index)}
                              className="cross_btn"
                            >
                              <span>x</span>
                            </button>
                          )}

                          <div className='d-lg-flex  justify-content-between gap-5 '>
                          <InputComponent
                              type="text"
                              width={"320px"}
                              label={"Medication"}
                              required={'*'}
                              fontWeight={600}
                              placeholder={"Enter Medication Details"}
                              name="medication_name"
                              value={input.medication_name}
                              onChange={(e) => handleInputMedicationUsedChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              fontWeight={600}
                              width={"320px"}
                              label={"Route/Site"}
                              name="medication_route"
                              placeholder={"Enter Route/Site Details"}
                              value={input.medication_route}
                              onChange={(e) => handleInputMedicationUsedChange(index, e)}
                            />
                          </div>
                          <div className='d-lg-flex  justify-content-between gap-5 '>
                            <InputComponent
                            required={'*'}
                              type="text"
                              fontWeight={600}
                              width={"320px"}
                              placeholder={"Enter Dosage"}
                              label={"Dosage"}
                              name="dosage"
                              value={input.dosage}
                              onChange={(e) => handleInputMedicationUsedChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              fontWeight={600}
                              width={"320px"}
                              label={"Frequency"}
                              name="frequency"
                              placeholder={"Enter Frequency"}
                              value={input.frequency}
                              onChange={(e) => handleInputMedicationUsedChange(index, e)}
                            />
                          </div> 
                        </div>
                      ))}
                    </Row>
                    {!medUsedInLast3WeeksDtlsBtn && <div className="addBtn">
                      <button
                        className="white_btn px-4 mt-3"
                        onClick={handleAddMedUsedInLast3WeeksFields}
                      >
                        Add
                      </button>
                    </div>}
                  </div>
                )}
              </div>
                </div>
              // </div>
            )}
            {regStep === 4 && (
              <div className="subject_reg_body">
                <div className='row d-flex gap-3 mt-0'>
                  <div className="col">
                    <label htmlFor="mrName">
                      Name of the study
                    </label>
                    <input
                      value={optedStudy?.study_name}
                      disabled
                      className="customInput"
                      id="firstName"
                      type="text"
                      placeholder="Enter study name"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleStudyChange}
                    />
                  </div>

                  <div className="col ">
                    <label htmlFor="dose">
                      Dose
                    </label>
                    <input
                      name="dose"
                      id="piStudy"
                      className="selectTag-subj subj_dose_input"
                      style={{ width: "380px" }}
                      value={`D${dose}`}
                      disabled
                      // onChange={handleDoseChange}
                    />
                      {/* <option>Select</option>
                      {dosesArray &&
                        dosesArray.map((dose) => (
                          <option key={dose} value={dose}>
                            Dose {dose}
                          </option>
                        ))}*/}
                  </div>
               
                 
                  <div className="col-12 col-lg col-md">
                    <label htmlFor="Rout of Administration">
                      Route of administration
                    </label>
                    {/* <select id='piStudy' className='selectTag'  style={{width:"380px"}} value={route}>
                                        <option>Oral</option>
                                    </select> */}
                    <input
                      value={optedStudy?.dose_administration_name}
                      className="customInput"
                      id="Rout of Administration"
                      type="text"
                      placeholder=""
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleStudyChange}
                      disabled
                    />
                  </div>
                  <div className="col col-12 col-lg col-md">
                    <label htmlFor="Anatomical">
                      Anatomical site of administration
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </label>
                    {/* <select id='piStudy' className='selectTag'  style={{width:"380px"}} value={anatomical} >
                                        <option>Mouth</option>
                                    </select> */}
                    <input
                      value={optedStudy?.anatomical_site_administration_name}
                      className="customInput"
                      id="Anatomical"
                      type="text"
                      placeholder=""
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleStudyChange}
                      disabled
                    />
                  </div>
                 
                  <div className="col">
                    <label htmlFor="date_of_administration">
                      Date of administration
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      value={dateOfAdministration?dateOfAdministration: moment().format("YYYY-MM-DD")}
                      className="customInput"
                      id="date_of_administration"
                      // disabled={dsblFrRejSub}
                      type="date"
                      placeholder="Enter here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px",cursor: "not-allowed" }}
                      onChange={handleDateOfAdministrationChange}
                      onKeyDown={(e) => e.preventDefault()}
                      max={moment().format("YYYY-MM-DD")}
                      min={minxDate}
                    />
                    
                  </div>

                  <div className="col-12 col-lg col-md">
                    <label htmlFor="time_of_administration">
                      Time of administration (24 hrs)
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={timeOfAdministration}
                      className="customInput"
                      id="time_of_administration"
                      type="time"
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleTimeOfAdministrationChange}
                    />
                    {timeOfAdministration?null:
                          <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                          }
                  </div>
                
                  <div className="col">
                    <label htmlFor="date_of_manufacture">
                      Date of manufacture<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={dateOfManu}
                      className="customInput"
                      id="date_of_manufacture"
                      type="date"
                      max={maxDate}
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px",cursor: "not-allowed" }}
                      onChange={handleDateOfManuChange}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {dateOfManu?null:
                          <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                          }
                    
                  </div>
                
                  

                  <div className="col">
                    <label htmlFor="expiry_date">
                      Expiry date<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={expiry}
                      className="customInput"
                      id="expiry_date"
                      type="date"
                      min={moment(today).format('YYYY-MM-DD')}
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" ,cursor: "not-allowed"}}
                      onChange={handleExpiryChange}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {expiry?null:
                          <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                          }
                  </div>
                  </div>

                  <div className="col">
                    <label htmlFor="mrName">
                      Batch number<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={batchNumber}
                      className="customInput"
                      id="firstName"
                      type="text"
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "380px" }}
                      onChange={handleBatchNumberChange}
                    />
                  </div>
                 
                 
                <div>
                  <div className="">
                    <label htmlFor="mrName">
                      Any adverse event within <b style={{color:"red"}}>{optedStudy?.immediate_adverse_event}</b>  min, post vaccination?
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          className="C-pointer"
                          value="yes"
                          checked={selectedOption === "yes"}
                          onChange={handleOptionChange}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Yes</span>
                      </label>

                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          className="C-pointer"
                          value="no"
                          checked={selectedOption === "no"}
                          onChange={handleOptionChange}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {regStep === 5 ? (
              selectedOption == "yes" ? (
                <div className="subject_reg_body">
                  <div className="d-flex align-items-center">
                    <label htmlFor="isthisseriousae">
                      Is this a serious adverse criteria?
                    </label>
                    <span style={{ marginLeft: "20px" }}>
                      <ToggleButton
                        value={toggleSAE}
                        onToggle={handleSaeToggle}
                        inactiveLabel={"No"}
                        activeLabel={"Yes"}
                        colors={{
                          activeThumb: {
                            base: "rgb(250,250,250)",
                          },
                          active: {
                            base: "rgb(209, 65, 65)",
                          },
                          inactive: {
                            base: "rgb((0, 128, 0)",
                          },
                        }}
                      />
                    </span>
                  </div>
                  {toggleSAE ? (
                    <div className="text-start d-flex flex-column justify-content-between">
                      

                      <Row className='mt-0'>
                        <div className="d-block d-md-flex justify-content-between my-0 my-md-3 my-xxl-3 ">
                                  <Col><label htmlFor="search_block">Serious Adverse Criteria<span className="text-danger">*</span></label></Col>
                                  <Col>
                                    <div className="search_block" id='search_block' >
                                        <div className="orange_btn cutm_btn_pdng searchNselectmbl" onClick={handleDropDown} style={{width:"350px", padding:"12px 14px"}}
                                        > {btnTitle.length > 30 ? btnTitle.slice(0, 30) + "..." : btnTitle || 'Select Adverse Criteria'}
                                            <img src="./images/icons/selectarrow.svg" alt="" />
                                        </div>
                                        {showPopup && <div className="search_main" onBlur={() => {
                                            setTimeout(() => {
                                                if (showPopup) {
                                                    setShowPopup(false)
                                                }
                                            }, 200)
                                        }}>
                                            <div className='drop_down_for_search'>
                                                <input
                                                    type="text"
                                                    autoFocus
                                                    value={searchTerm}
                                                    onChange={handleSearch}
                                                    placeholder="Search..."
                                                />
                                                <img className='sasd' src="./images/icons/search.svg" alt="" />
                                                <div className="eventlist_items">
                                                    { saEvents &&
                                                                    saEvents.filter(i => {
                                                        const event = i.serious_adverse_event_name || '';
                                                        return event.toLowerCase().includes((searchTerm || '').toLowerCase())
                                                    }).map((i, index) => {
                                                    
                                                        return (
                                                            <ul className='aelistdropdown ps-2' key={index}>
                                                                <li className={`${i.serious_adverse_event_name === btnTitle ? 'selectedOption' : ''}`} onClick={() => handleOption(i)}
                                                                >{i.serious_adverse_event_name|| 'Select Adverse Criteria'}</li>
                                                            </ul>
                                                        )
                                                    })}
                                                </div></div>
                                        </div>}
                                    </div>
                                  </Col>
                              </div>
                      </Row>



                    </div>
                  ) : null}
                  {<img src="images/icons/downArrowCustm.svg" alt="" /> &&<Row className="text-start mt-0">
                  <div className="d-block d-md-flex justify-content-between my-0 my-md-3 my-xxl-3 ">

                    <Col className="align-self-center">
                      <label htmlFor="aeCalssification">
                        Adverse Event Classification<span className="text-danger">*</span>
                      </label>
                    </Col>

                    <Col className="subrej-custom-select-styl">
                      

                      <select 
                       id="aeCalssification"
                        className="orange_select"
                        value={aEClassification}
                        onChange={handleAEClassification}
                      >
                      <option >Select Adverse Event</option>
                      {studyTitles &&
                          studyTitles?.map((i) => {
                            return(
                        <option key={i.study_aebank_id}
                        label={i.study_aebank_event_title}
                        value={i.study_aebank_id}
                        case_def={i.study_case_definition}>{i.study_aebank_event_title}</option>

                            )
                          })}
                      </select>
                    </Col>
                    </div>
                  </Row>}
                  {aEClassification !== "" ? (
                   
                    <div className="advEventGroup">
                      <div className={`${caseDef !== EVENT_CLASSIFICATION_OTHER?  'p-2 p-md-4 p-xxl-4':""} bg-light rounded eventClassificationDiv`}>
                        {caseDef === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? (
                            <div className="accordianClass">
                            <BrightonCase handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset}  getEventDescId={getEventDescId}/>
                            </div>
                          
                        ) : caseDef === EVENT_CLASSIFICATION_GRADE_CTCAE ? (
                          <Accordion >
                        <GradeCase handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset}  getEventDescId={getEventDescId}/>
                        </Accordion>
                        ) : caseDef === EVENT_CLASSIFICATION_AESI?
                        <Accordion >
                        <div className="fs-6 " dangerouslySetInnerHTML={{ __html: studyAeDtls&& studyAeDtls[0]?.other_case?.study_aesi_description.replace(/(?:\r\n|\r|\n)/g, '<br>') }}></div> 
                        </Accordion> 
                        :(
                         null
                        )}
                      </div>

                       {caseDef === EVENT_CLASSIFICATION_AESI && 
                       
                        <div className={JustBtwn}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "start",
                          }}
                        >
                          <label htmlFor="input_notes">
                          Event Description<span className="text-danger">*</span>
                          </label>
                          <textarea
                            id="input_notes"
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              padding:"10px",
                              borderColor: "#E1E5E7",
                              borderRadius: "8px",
                            }}
                            value={inputTextNotes}
                            name={"other_input_notes"}
                            placeholder="type here"
                            onChange={handleAesiInputText}
                          />
                        </div>
                      </div>
                      }

                        {caseDef === EVENT_CLASSIFICATION_OTHER && 
                        
                          <div className={JustBtwn}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "start",
                          }}
                        >
                          <label htmlFor="input_notes">
                          Event Description<span className="text-danger">*</span>
                          </label>
                          <textarea
                            id="input_notes"
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              padding:"10px",
                              borderColor: "#E1E5E7",
                              borderRadius: "8px",
                            }}
                            value={inputTextNotes}
                            name={"other_input_notes"}
                            placeholder="type here"
                            onChange={handleAesiInputText}
                          />
                        </div>
                      </div>
                      

                        }


                        <div className="d-lg-flex justify-content-between mb-2">
                    <div className="mb-3">
                      <label htmlFor="date_of_onset" className="custm_label_fw">
                        Date of onset<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={fifthInputs.date_of_onset}
                        className="customInput "
                        id="date_of_onset"
                        max={moment(today).format('YYYY-MM-DD')}
                        min={dateOfAdministration===''?moment(today).format('YYYY-MM-DD'):dateOfAdministration}
                        name='date_of_onset'
                        type="date"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "10px 12px", width: "340px" ,cursor: "not-allowed"}}
                        onChange={handleAeOptions}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      {fifthInputs.date_of_onset?null:
                          <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                          }
                    </div>
                      {(dateOfAdministration ? dateOfAdministration : moment().format("YYYY-MM-DD")) === fifthInputs.date_of_onset ? 
                    <div className="">
                      <label htmlFor="time_of_onset" className="custm_label_fw">
                        Time of onset (24 Hrs)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={fifthInputs.time_of_onset}
                        className="customInput "
                        name='time_of_onset'
                        id="time_of_onset"
                        type="time"
                        min={timeOfAdministration}
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "10px 12px", width: "340px" }}
                        onChange={handleAeOptions}
                        onInput={validateTimeOfOnset1}
                        />
                        {fifthInputs.time_of_onset?null:
                          <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                          }
                        <span style={{color:"red", fontSize:"14px"}}>
                          {showTimeError1? timeError1 : null}
                        </span>
                    </div>
                    :
                    <div className="">
                      <label htmlFor="time_of_onset" className="custm_label_fw">
                        Time of onset (24 Hrs)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={fifthInputs.time_of_onset}
                        className="customInput "
                        name='time_of_onset'
                        id="time_of_onset"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "10px 12px", width: "340px" }}
                        onChange={handleAeOptions}
                      />
                      {fifthInputs.time_of_onset?null:
                          <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                          }
                    </div>
                    }
                  </div>
                  <div className="d-lg-flex justify-content-between ">
                    <div className="mb-3">
                      <label
                        htmlFor="dateOfResolution"
                        className="custm_label_fw"
                      >
                        Date of resolution
                         
                      </label>
                      <input
                        value={dateOfResolution}
                        className="customInput"
                        id="dateOfResolution"
                        max={moment(today).format('YYYY-MM-DD')}
                        min={fifthInputs.date_of_onset}
                        type="date"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "10px 12px", width: "340px",cursor: "not-allowed" }}
                        onChange={handleDateOfResolutionChange}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      {dateOfResolution?null:
                          <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                          }
                    </div>
                    {fifthInputs.date_of_onset === dateOfResolution ? 
                    <div className="">
                    <label htmlFor="time_of_resolution" className="custm_label_fw">
                      Time of resolution (24 Hrs)
                      
                    </label>
                    <input
                      value={timeOfResolution}
                      className="customInput"
                      id="time_of_resolution"
                      type="time"
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "10px 12px", width: "340px" }}
                      onChange={handleTimeOfResolutionChange}
                      min={fifthInputs.time_of_onset}
                      onInput={validateTimeOfResolution}
                      />
                      {timeOfResolution?null:
                          <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                          }
                      <span style={{color:"red", fontSize:"14px"}}>
                        {showTimeError? timeError : null}
                      </span>
                  </div>
                  :
                  <div className="">
                      <label htmlFor="time_of_resolution" className="custm_label_fw">
                        Time of resolution (24 Hrs) {dateOfResolution && <span style={{ color: "red" }}>*</span> }
                        
                      </label>
                      <input
                        value={timeOfResolution}
                        className="customInput"
                        id="time_of_resolution"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "10px 12px", width: "340px" }}
                        onChange={handleTimeOfResolutionChange}
                      />
                      {timeOfResolution?null:
                          <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                          }
                    </div>
                  }
                    
                  </div>

                  <div className="  coaadrpdnsdsk">
                        <div className="">
                          <label htmlFor="causality">
                            Causality<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="causality"
                            value={fifthInputs.causality_id}
                            name='causality_id'
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {causalities &&
                              causalities.map((i) => {
                                return (
                                  <option
                                    key={i.causality_id}
                                    value={i.causality_id}
                                  >
                                    {i.causality_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        </div>
                        <div className="">
                          <label htmlFor="outCome">
                            Outcome <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="outCome"
                            className="selectTag"
                            name='outcome_id'
                            value={fifthInputs.outcome_id}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {outComes &&
                              outComes.map((i) => {
                                return (
                                  <option value={i.outcome_id} key={i.outcome_id}>
                                    {i.outcome_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                        </div>
                        </div>
                        
                        <div className="  coaadrpdnsdsk"> 
                      <div className="">
                          <label htmlFor="action_taken_for_ae">
                            Action Taken For Adverse Event <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="action_taken_for_ae"
                            className="selectTag"
                            name='action_taken_for_ae'
                            value={fifthInputs.action_taken_for_ae}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {actionTakenforAe &&
                              actionTakenforAe.map((i) => {
                                return (
                                  <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                    {i.action_taken_for_adverse_event_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                          {(newFlag!=="None" && !flag) && (
        <div className="start-end-date">
          <label htmlFor="startDate" className="custm_label_fw">
          Treatment Start Date{dateOfResolution&&<span className="text-danger">*</span>}
          </label>
          <input
            value={startDate}
            className="custminputbml "
            id="startDate"
            type="date"
            placeholder="Enter Start Date"
            aria-placeholder="#D4D4D4"
            style={{ padding: "10px 12px", width: "340px" }}
            onChange={handleStartDateChange}
            min={fifthInputs?.date_of_onset} 
          />
        </div>
      )}

     
      </div>

                        <div className="">
                          <label htmlFor="actionTaken">
                            Action Taken For Study Vaccine<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="actionTaken"
                            name='action_taken_id'
                            value={fifthInputs.action_taken_id}
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {actnTakenOpts &&
                              actnTakenOpts.map((i) => {
                                return (
                                  <option
                                    key={i.action_taken_id}
                                    value={i.action_taken_id}
                                  >
                                    {i.action_taken_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                         {/* End Date input */}
                         {(newFlag!=="None" && !flag) && (
        <div className="start-end-date">
          <label htmlFor="endDate" className="custm_label_fw">
          Treatment End Date{dateOfResolution && <span className="text-danger">*</span>}
          </label>
          <input
            value={endDate}
            className="custminputbml"
            id="endDate"
            type="date"
            disabled={!startDate}
            placeholder="Enter End Date"
            aria-placeholder="#D4D4D4"
            style={{ padding: "10px 12px", width: "340px" }}
            onChange={handleEndDateChange}
            min={startDate}
          />
        </div>
      )}
                        </div>
                        </div>

                        {/* ////////////////////// */}
                        <div className="coaadrpdnsdmbl">
                          <label htmlFor="causality">
                            Causality<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="causality"
                            value={fifthInputs.causality_id}
                            name='causality_id'
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {causalities &&
                              causalities.map((i) => {
                                return (
                                  <option
                                    key={i.causality_id}
                                    value={i.causality_id}
                                  >
                                    {i.causality_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        </div>
                        <div className="coaadrpdnsdmbl">
                          <label htmlFor="outCome">
                            Outcome <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="outCome"
                            className="selectTag"
                            name='outcome_id'
                            value={fifthInputs.outcome_id}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {outComes &&
                              outComes.map((i) => {
                                return (
                                  <option value={i.outcome_id} key={i.outcome_id}>
                                    {i.outcome_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                        </div>

                        <div className="coaadrpdnsdmbl">
                          <label htmlFor="action_taken_for_ae">
                            Action Taken For Adverse Event <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="action_taken_for_ae"
                            className="selectTag"
                            name='action_taken_for_ae'
                            value={fifthInputs.action_taken_for_ae}
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>
                             Select
                            </option>
                            {actionTakenforAe &&
                              actionTakenforAe.map((i) => {
                                return (
                                  <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                    {i.action_taken_for_adverse_event_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                          {(newFlag!=="None" && !flag) && (
        <div className="start-end-date">
          <label htmlFor="startDate" className="custm_label_fw start-date">
          Treatment Start Date {dateOfResolution&&<span className="text-danger">*</span>}
          </label>
          <input
            value={startDate}
            className="custminputbml selectTag "
            id="startDate"
            type="date"
            placeholder="Enter Start Date"
            aria-placeholder="#D4D4D4"
            style={{ padding: "10px 12px", width: "340px" }}
            onChange={handleStartDateChange}
            min={fifthInputs?.date_of_onset} 
          />
        </div>
      )}

      {/* End Date input */}
      {(newFlag!=="None" && !flag) && (
        <div className="start-end-date">
          <label htmlFor="endDate" className="custm_label_fw end-date">
          Treatment End Date {dateOfResolution&&<span className="text-danger">*</span>}
          </label>
          <input
            value={endDate}
            className="custminputbml selectTag"
            id="endDate"
            type="date"
            disabled={!startDate}
            placeholder="Enter End Date"
            aria-placeholder="#D4D4D4"
            style={{ padding: "10px 12px", width: "340px" }}
            onChange={handleEndDateChange}
            min={startDate}
          />
        </div>
      )}
      </div>

                        <div className="coaadrpdnsdmbl">
                          <label htmlFor="actionTaken">
                            Action Taken For Study Vaccine<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            id="actionTaken"
                            name='action_taken_id'
                            value={fifthInputs.action_taken_id}
                            className="selectTag"
                            style={{ width: "345px" }}
                            onChange={handleAeOptions}
                          >
                            <option value={"Select"}>Select</option>
                            {actnTakenOpts &&
                              actnTakenOpts.map((i) => {
                                return (
                                  <option
                                    key={i.action_taken_id}
                                    value={i.action_taken_id}
                                  >
                                    {i.action_taken_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        </div>


                  {/* ////////////////////// */}








                      <div className={JustBtwn}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "start",
                          }}
                        >
                          <label htmlFor="treatment_given">
                            Any treatment given
                          </label>
                          <textarea
                            id="treatment_given"
                            style={{
                              width: "100%",
                              minHeight: "100px",
                              padding:"10px",
                              borderColor: "#E1E5E7",
                              borderRadius: "8px",
                            }}
                            value={treatmentGiven}
                            placeholder="type here"
                            onChange={handleTreatment}
                          />
                        </div>
                      </div>
                      <div>
                        <span
                          style={{ display: "flex", alignContent: "start" }}
                        >
                          <label htmlFor="file-input-label">Attach files</label>
                        </span>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "20px",
                          }}
                        >
                          <div
                            style={{ width: "500px", alignItems: "center" }}
                            className='subjreg_drop_zone'
                            id="drop-area"
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                          >
                            <div className="upload-icon" style={{}}>
                              <img
                                style={{
                                  height: "100px",
                                  margin: "6px",
                                  paddingLeft: "5px",
                                }}
                                src="./images/icons/Upload.svg"
                                alt=""
                              />
                              <h5 className='subjreg_drp_zone_txt'>Drag and drop files here </h5>
                              <h5 className='subjreg_drp_zone_txt'>or</h5>
                              <input
                                type="file"
                                id="file-input"
                                multiple
                                onChange={handleFileUpload}
                                disabled={fileNames.length >=3 ?true:false}
                                accept=".pdf, .ppt, .txt, .docx, .doc, .xls, .csv, .jpeg, .jpg, .png"
                              />
                              <label
                                htmlFor="file-input"
                                className=""
                              >
                                <span className="gray_btn px-4" style={{opacity:fileNames.length >=3 ? "50%":''}}>Browse Files</span>
                              </label>
                              <p  >(PDF, PPT, TXT, DOCX, DOC, XLS, CSV, JPEG, JPG, PNG)</p>
                            </div>
                            <div id="file-list" style={{ margin: "10px" }}>
                            {fileNames.map((fileName, index) => (
                                <div key={fileName} className="file-container">
                                  <div>{fileName}</div>
                                  {/* <button className="close-icon" onClick={() => handleRemoveFile(index)}>
                                    X
                                  </button> */}
                                  <span className='close-icon' style={{ color: 'red'}} title='Click on this to delete the file' onClick={() => handleRemoveFile(index)}>✕</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="center_txt">
                  <h5 className='noaetxtmbl'>
                    As no adverse events were reported within {optedStudy?.immediate_adverse_event} minutes post
                    vaccination, <br />
                    you may continue.
                  </h5>
                </div>
              )
            ) : (
              ""
            )}
            {regStep === 6 && (
              <div className="subject_reg_body">
                <div>
                  <div className="">
                    <label htmlFor="mrName">
                      Concomitant medication administered at the same time, as
                      applicable
                    </label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="radio"
                          value="yes"
                          checked={concomitantRadio === "yes"}
                          onChange={handleConcomitantRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Yes</span>
                      </label>

                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          value="no"
                          checked={concomitantRadio === "no"}
                          onChange={handleConcomitantRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>No</span>
                      </label>
                    </div>
                  </div>
                </div>
                {concomitantRadio === "yes" && (
                  <div className="concomitant_container">
                    <Row className="mt-0 ps-2 ps-md-0">
                      {medicationDetails.map((input, index) => (
                        <div
                          key={input.id}
                          className="position-relative concomitant_detials px-3 mt-4"
                        >
                          {index !== 0 && (
                            <button
                              onClick={() => handleDeleteFields(input, index)}
                              className="cross_btn"
                            >
                              <span>x</span>
                            </button>
                          )}

                          <div className='d-lg-flex  justify-content-between gap-5 '>
                          <InputComponent
                              type="text"
                              width={"320px"}
                              label={"Medication"}
                              required={'*'}
                              fontWeight={600}
                              placeholder={"Enter Medication Details"}
                              name="medication"
                              value={input.medication}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              width={"320px"}
                              fontWeight={600}
                              label={"Manufacturer"}
                              placeholder={"Enter Manufacturer Details"}
                              name="medication_manufacturer"
                              value={input.medication_manufacturer}
                              onChange={(e) => handleInputChange(index, e)}
                            />

                          </div>

                         <div className='d-lg-flex  justify-content-between gap-5 '>
                            <InputComponent
                            required={'*'}
                              type="text"
                              fontWeight={600}
                              width={"320px"}
                              placeholder={"Enter Batch Number"}
                              label={"Batch Number"}
                              name="medication_batch_number"
                              value={input.medication_batch_number}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              fontWeight={600}
                              width={"320px"}
                              label={"Route/Site"}
                              name="medication_route_site"
                              placeholder={"Enter Route/Site Details"}
                              value={input.medication_route_site}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </div>

                          <div className='d-lg-flex  justify-content-between gap-5 '>
                            <InputComponent
                            required={'*'}
                              type="text"
                              fontWeight={600}
                              width={"320px"}
                              placeholder={"Enter Dosage"}
                              label={"Dosage"}
                              name="medication_dosage"
                              value={input.medication_dosage}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              fontWeight={600}
                              width={"320px"}
                              label={"Frequency"}
                              name="medication_frequency"
                              placeholder={"Enter Frequency"}
                              value={input.medication_frequency}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </div> 

                         
                        </div>
                      ))}
                    </Row>
                    {!medicationDtlsBtn && <div className="addBtn">
                      <button
                        className="white_btn px-4 mt-3"
                        onClick={handleAddFields}
                      >
                        Add
                      </button>
                    </div>}
                  </div>
                )}
              </div>
            )}
            {regStep === 7 && (
              <div className="subject_reg_body px-3">
                <div className= 'row d-flex justify-content-center justify-content-md-between gap-3 gap-md-5 gap-xxl-5 mt-2'>
                  <div className="card viewCardStyl col-12 col-md-5 col-lg-5 ">
                    <div className="card-header cardHeading " >
                      <h6>Subject Details</h6>
                    </div>
                    <div className="table-responsive body ">
                      <table className="table card_columns_styl border-0">
                        <tbody>
                        <tr>
                            <td>Subject ID</td>
                            <td>{subjNumber?.sequence_number}</td>
                          </tr>
                          <tr>
                            <td>Subject Name</td>
                            <td style={{ minWidth: "14rem" }}>{firstPgInputs?.first_name} {firstPgInputs?.last_name}</td>
                          </tr>
                          <tr>
                            <td>Age</td>
                            <td>{age}</td>
                          </tr>
                          <tr>
                            <td>Mobile</td>
                            <td>{subjPhone}</td>
                          </tr>
                          <tr>
                            <td>Gender</td>
                            <td>{gender}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
 
                  <div className="card viewCardStyl col-12 col-md-5 col-lg-5" >
                    <div className="card-header cardHeading">
                      <h6>Site Information</h6>
                    </div>
                    <div className="table-responsive body">
                      <table className='table card_columns_styl border-0'>
                        <tbody>
                          <tr>
                            <td>Zone</td>
                            <td>{piDetails?.pi_sites?.zone_name}</td>
                          </tr>
                          <tr>
                            <td>State</td>
                            <td>{piDetails?.state}</td>
                          </tr>
                          <tr>
                            <td>City</td>
                            <td>{piDetails?.city}</td>
                          </tr>
                          <tr>
                            <td>Site Name</td>
                            <td>{piDetails?.pi_sites?.site_name}</td>
                          </tr>
                          <tr>
                            <td>Mobile Number</td>
                            <td> +91 {piDetails?.pi_sites?.phone_number}</td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>


                  <div className="card viewCardStyl col-12 col-md-5 col-lg-5" >
                    <div className="card-header cardHeading">
                      <h6>Study Details</h6>
                    </div>
                    <div className=" cardBody">
                      <div className="table-responsive body">
                        <table className="table card_columns_styl border-0">
                          <tbody>
                            <tr>
                              <td>Study Name</td>
                              <td>{optedStudy?.study_name.length > 25 ? optedStudy?.study_name.slice(0, 25) + "..." : optedStudy?.study_name}</td>
                            </tr>
                            <tr>
                              <td>Route of administration</td>
                              <td>{optedStudy?.dose_administration_name}</td>
                            </tr>
                            <tr>
                              <td>Batch No.</td>
                              <td>{batchNumber}</td>
                            </tr>
                            <tr>
                              <td>Date of Administration</td>
                              <td>{moment(dateOfAdministration || today).format("DD-MM-YYYY")}</td>
                            </tr>
                            <tr>
                              <td>Expiry Date</td>
                              <td>{moment(expiry).format("DD-MM-YYYY")}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>


                 
                


                  <div className="card step5_cards viewCardStyl col-12 col-md-5 col-lg-5">
                    <div className="card-header cardHeading">
                      <h6>Adverse Events</h6>
                    </div>
                    <div className=" cardBody table-responsive body">
                      <table className="table card_columns_styl border-0 ">
                        <tbody>
                          <tr>
                            <td>Date & Time of onset</td>
                            {/* <td>{moment(fifthInputs.date_of_onset).format('DD-MM-YYYY')} {fifthInputs.time_of_onset} </td> */}
                            {/* <td>{fifthInputs.date_of_onset ? moment(fifthInputs.date_of_onset).format('DD-MM-YYYY ') + " " + fifthInputs.time_of_onset : '-'}</td> */}
                            <td>{fifthInputs.date_of_onset ? moment(fifthInputs.date_of_onset).format('DD-MM-YYYY ') + " " +  moment(fifthInputs.time_of_onset, 'HH:mm').format('hh:mm A') : '-'}</td>


                          </tr>
                          <tr>
                            <td>Date & Time of Resolution</td>
                            <td>{dateOfResolution ? moment(dateOfResolution).format('DD-MM-YYYY')+" "+ moment(timeOfResolution, 'HH:mm').format('hh:mm A') : '-'}</td>
                          </tr>
                          <tr>
                            <td>Adverse Event</td>
                            <td>{aeLabel===undefined?'-':aeLabel}</td>
                          </tr>
                          <tr>
                            <td>Serious Adverse Criteria</td>
                            <td>{seriousAE.label?seriousAE.label:'-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>


                <div className="card viewCardStyl col-12 col-md-5 col-lg-5" >
                    <div className="card-header cardHeading">
                      <h6>Past Health History</h6>
                    </div>
                    <div className="  table-responsive body">
                      <table className="table card_columns_styl border-0">
                        <tbody>
                          <tr>
                            <td>Allergies</td>
                            <td>{anyAllergies === '' ? '-' :anyAllergies}</td>
                          </tr>
                          <tr>
                            <td>Medical History</td>
                            <td>{medicalHistory === '' ? '-' : medicalHistory}</td>
                          </tr>
                          <tr>
                            <td>Illness</td>
                            <td>{ConcurrentIllness === '' ? '-' : ConcurrentIllness}</td>
                          </tr>
                         
                        </tbody>
                      </table>
                    </div>
                  </div>

                  
                  <div className="card viewCardStyl  col-12 col-md-5 col-lg-5 w-100" >
                    <div className="card-header  cardHeading">
                      <h6>Medication used in last 3 weeks</h6>
                    </div>
                    <div className=" cardBody w-100">
                      {medUsedInLast3WeeksRadio === 'yes' ? (
                        <div className=" body Concon_medication_main w-100">
                          <table className="table Concon_medication w-100 text-center">
                            <thead>
                              <tr>
                                <th scope="col">Medication</th>
                                <th scope="col">Route/Site</th>
                                <th scope="col">Dosage</th>
                                <th scope="col">Frequency</th>
                              </tr>
                            </thead>
                            <tbody>
                              {medUsedInLast3WeeksDetails?.map((i, index) => {
                                return (
                                  <tr key={index} className='text-center'>
                                    <td>{i.medication_name}</td>
                                    <td>{i.medication_route}</td>
                                    <td>{i.dosage}</td>
                                    <td>{i.frequency}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        ):(
                        <div className="concomitantMsg">
                          <p className='Con_medication'>No Medication used in last 3 weeks</p>
                        </div>)}
                    </div>
                  </div>

                  <div className="card viewCardStyl col-12 col-md-5 col-lg-5 w-100" >
                    <div className="card-header cardHeading">
                      <h6>Concomitant Medication</h6>
                    </div>
                    <div className=" cardBody w-100">
                      {concomitantRadio === 'yes' ?(
                        <div className=" body Concon_medication_main w-100 ">
                          <table className="table Concon_medication w-100 text-center">
                            <thead>
                              <tr>
                                <th scope="col">Medication</th>
                                <th scope="col">Batch Number</th>
                                <th scope="col">Manufacturer</th>
                                <th scope="col">Route/Site</th>
                                <th scope="col">Dosage</th>
                                <th scope="col">Frequency</th>
                              </tr>
                            </thead>
                            <tbody>
                              {medicationDetails?.map((i, index) => {
                                return (
                                  <tr key={index} className='text-center'>
                                    <td>{i.medication}</td>
                                    <td>{i.medication_batch_number}</td>
                                    <td>{i.medication_manufacturer}</td>
                                    <td>{i.medication_route_site}</td>
                                    <td>{i.medication_dosage}</td>
                                    <td>{i.medication_frequency}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                       ) :(
                        <div className="concomitantMsg ">
                          <p className=''>No Concomitant Medication</p>
                        </div>)}
                    </div>
                  </div>



</div>
                
              </div>
            )}

            <div className="registrationStepsFooter">
            {regStep === 1 && (
                <button
                  className="white_btn px-4 exit_white_btn_mbl"
                  onClick={handleExitSubRej}
                >
                  Cancel
                </button>
              )}
              {regStep > 1 && (
                <button
                  className="white_btn white_btn_mbl"
                  onClick={() => handleStepChange(-1)}
                >
                  Previous
                </button>
              )}
              {regStep === 1 && (
                <button
                  disabled={
                     !(phoneValidation && firstDisable&& subjPhone!=='' && gender !== "" && weight !=='' && height !=="")
                  }
                  className={next}
                  onClick={handleNavigateNext}
                >
                  Next
                </button>
              )}
              {regStep === 2 && (
               
                <button
                  className={next}
                  onClick={() => handleStepChange(1)}
                >
                  Next
                </button>
              )}

              {regStep === 3 && (
                <button
                  className={next}
                  onClick={() => handleStepChange(1)}
                  disabled={medUsedInLast3WeeksRadio==='yes' ? medUsedInLast3WeeksDtlsBtn : false}
                >
                  Next
                </button>
              )}
              {regStep === 4 && (
                <button
                  className={next}
                  onClick={() => handleStepChange(1)}
                  disabled={!(selectedOption!=='' && batchNumber!==''&&dateOfManu!=='' &&expiry!=='' && timeOfAdministration!=='')}
                >
                  Next
                </button>
              )}
              {regStep === 5 && (
                <button
                  className={next}
                  onClick={ () => handleStepChange(1) }
                  disabled={
  selectedOption==='no' ? false:
toggleSAE && seriousAE!=='' && aEClassification!=='' &&eventDesc!==undefined && inputTextNotes !=='' && fifthDisable && !dateOfResolution  ?false:
toggleSAE && seriousAE!=='' && aEClassification!=='' &&eventDesc!==undefined && inputTextNotes !=='' && fifthDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate  ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && fifthDisable && ! dateOfResolution ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && fifthDisable && ! dateOfResolution ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && fifthDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && fifthDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:

 !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && fifthDisable && dateOfResolution && selectedAction ==='None' ?false:
!toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && fifthDisable && dateOfResolution && selectedAction ==='None' ?false:

toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && !dateOfResolution ?false:
toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && !dateOfResolution ?false:

toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && dateOfResolution && selectedAction !=='None' &&startDate && endDate ?false:
toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && dateOfResolution && selectedAction ==='None' &&!startDate && !endDate ?false:

toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && dateOfResolution && selectedAction ==='None' && !startDate && !endDate ?false:
toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && fifthDisable && dateOfResolution && selectedAction !=='None' && startDate && endDate ?false:

 
true 
                  }
                >
                  Next
                </button>
              )}

                 
              {regStep === 6 && (
                <button
                  className={next}
                  onClick={() => handleStepChange(1)}
                  disabled={concomitantRadio==='yes' ? medicationDtlsBtn : false}
                >
                  Next
                </button>
              )}

              {regStep === 7 && (
                <button disabled={isbtnDisabled} className="orange_btn orange_btn_mbl" onClick={handelSubjectCreate}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <PopUpModal
      handleClose={handleClosePopup}
      open={open}
      title={"Success!"}
      msg={"Subject created successfully!"}
      close={"Close"}
      actionbtn={"Done"}
      onConfirm={handleReviewActions}
  />
    </div>
     {loading && <Loader />}
    </>

   
  );
}
